import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import twitterfeed from '../../data/twitterfeed.json';
import HeaderComponent from '../../helper/Navigationhelper';
import blogbox from '../../data/blog.json';
import Slider from 'react-slick';
import { t } from 'i18next'
import axios from 'axios';
import { API_URL } from '../../constants';
import { Alert } from 'react-bootstrap';
import WhatsappFloatIcon from '../sections/home/whatsappFloatIcon';

class Footer extends HeaderComponent {

    constructor(props) {
        super(props)
        this.state = {
            email: ""
        }

        this.handleSubmit = this.handleSubmit.bind(this);
    }


    handleSubmit(e) {
        e.preventDefault();

        axios.post(`${API_URL}/subscribe/`, {
            email: this.state.email
        }).then((respose) => {

            if (respose.status === 200) {
                document.getElementById("server_response_success_subscribe").classList.add("d-block");
                this.setState({ email: "" })
            } else {
                document.getElementById("server_response_danger_subscribe").classList.add("d-block");
            }
        }).catch((error) => {
            // console.log(error)
            document.getElementById("server_response_danger_subscribe").classList.add("d-block");
        })


    }


    render() {
        const classNames = this.state.isTop ? 'd-block' : '';
        const settings = {
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            vertical: true,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 3000,
            cssEase: 'linear',
            pauseOnHover: true
        }
        return (
            <Fragment>
                <footer className="bg-black section-padding footer">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 col-sm-6">
                                <div className="footer-box mb-md-80">
                                    <div className="footer-heading">
                                        <h4 className="text-custom-white no-margin">{t("useful links")}</h4>
                                    </div>
                                    <ul className="custom links">
                                        <li> <Link to="/account-types" className="text-custom-white">{t("i need an account")}</Link>
                                        </li>
                                        <li> <Link to="/investment-options" className="text-custom-white">{t("i want to invest")}</Link>
                                        </li>
                                        <li> <Link to="/international-wire-transfer" className="text-custom-white">{t("I want to make an international wire transfer")}</Link>
                                        </li>
                                        <li> <Link to="/blog" className="text-custom-white">{t("financial health")}</Link>
                                        </li>
                                        <li> <Link to="/about" className="text-custom-white">{t("about us")}</Link>
                                        </li>
                                        <li> <Link to="/contact" className="text-custom-white">{t("contact")}</Link>
                                        </li>
                                        <li> <Link to="/privacy-policy" className="text-custom-white">{t("privacy policy title")}</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-sm-6">
                                <div className="footer-box mb-md-80">
                                    <div className="footer-heading">
                                        <h4 className="text-custom-white no-margin">{t("financial health")}</h4>
                                    </div>
                                    <ul className="custom popular_post">
                                        {blogbox.slice(0, 2).map((item, i) => (
                                            <li key={i}>
                                                <div className="post">
                                                    <div className="post-wrapper">
                                                        <div className="popular_post_img animate-img">
                                                            <Link to={"/blog-single/" + item.id}>
                                                                <img src={process.env.PUBLIC_URL + "/" + item.photo} className="img-fluid image-fit" alt={item.title} />
                                                            </Link>
                                                        </div>
                                                        <div className="popular_post_title">
                                                            <h6><Link to={"/blog-single/" + item.id} className="text-custom-white fs-14 fw-400">{item.title}</Link></h6>
                                                            <div className="post-date">
                                                                <p className="text-white no-margin">{item.postdate}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-sm-6">
                                <div className="footer-box mb-xs-80">
                                    <div className="footer-heading">
                                        <h4 className="text-custom-white no-margin">{t("twitter")}</h4>
                                    </div>
                                    <Slider className="custom twitter-feed twitter-slider" {...settings}>
                                        {twitterfeed.map((item, i) => (
                                            <>
                                                <li key={i}>
                                                    <p className="tweet">{item.tweet}</p>
                                                    <p className="timePosted"><Link to={item.link}>Posted on {item.tweetdate}</Link>
                                                    </p>
                                                </li>
                                                <img src={process.env.PUBLIC_URL + "assets/images/twitterx-fill.png"} className="twitter-feed-logo" alt="Twitterx" />
                                            </>

                                        ))}
                                    </Slider>
                                </div>
                            </div>
                            <div className="col-lg-3 col-sm-6">
                                <div className="footer-box">
                                    <div className="footer-heading">
                                        <h4 className="text-custom-white no-margin">{t("news londonbank")}</h4>
                                    </div>
                                    <div className="newsletter">
                                        <form onSubmit={this.handleSubmit}>
                                            <div className="form-group">
                                                <input type="email" onChange={(e) => this.setState({ email: e.currentTarget.value })} value={this.state.email} className="form-control form-control-custom" placeholder="Email" />
                                            </div>
                                            <button className="btn-first btn-submit-fill btn-height full-width" type="submit">{t("subscribe calltoaction")}</button>
                                            <Alert variant="success" className="d-none mt-3 mb-0" id="server_response_success_subscribe">
                                                <strong>{t("success form title subscribe")}</strong>
                                            </Alert>
                                            <Alert variant="danger" className="d-none mt-3 mb-0" id="server_response_danger_subscribe">
                                                <strong>{t("error form title")}</strong> {t("error form description subscribe")}
                                            </Alert>
                                        </form>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
                <div className="copyright">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <p className="text-custom-white no-margin">
                                    © 2025 LondonBank <br /> <small>Company Number: 06396997</small>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Footer */}
                <div id="back-top" className={`back-top ${classNames}`}>
                    <Link to="#" onClick={() => this.scrollToTop()}><i className="flaticon-up-arrow" /></Link>
                </div>

                <WhatsappFloatIcon />
            </Fragment>
        );
    }
}

export default Footer;